module.exports = "/static/assets/c134e2adffa7d75c07dda2e2374987f5.png";